
    const data = {"name":"src/core/icons/minus","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 13H5v-2h14v2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            